import { render, staticRenderFns } from "./ManPortrait.vue?vue&type=template&id=1adf38ce&scoped=true&"
import script from "./ManPortrait.vue?vue&type=script&lang=js&"
export * from "./ManPortrait.vue?vue&type=script&lang=js&"
import style0 from "./ManPortrait.vue?vue&type=style&index=0&id=1adf38ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf38ce",
  null
  
)

export default component.exports